module.exports = __webpack_public_path__ + "img/296.f1e53717.jpg";